import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import { telegramWebApp, type TelegramWebApp } from "./telegram";

/** Telegram's «Назад» in its top bar: shown once the person has gone somewhere inside Vekha, it goes back by history. */
export function useTelegramBackButton(): void {
  // Subscribed to the location: the history index below is read again on every move.
  useLocation();
  const navigate = useNavigate();
  const [app, setApp] = useState<TelegramWebApp | null>(null);
  useEffect(() => {
    let alive = true;
    void telegramWebApp().then((value) => { if (alive) setApp(value); });
    return () => { alive = false; };
  }, []);
  // React Router keeps the entry's index in history.state: a redirect that replaced the first entry is still the first.
  const index: unknown = (window.history.state as { idx?: unknown } | null)?.idx;
  const canGoBack = typeof index === "number" && index > 0;
  useEffect(() => {
    const button = app?.BackButton;
    if (!button) return;
    if (!canGoBack) { button.hide(); return; }
    const back = () => navigate(-1);
    button.onClick(back);
    button.show();
    return () => button.offClick(back);
  }, [app, canGoBack, navigate]);
}
